module.exports = __webpack_public_path__ + "static/img/sm_22.d57448e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_22.png
// module id = +/Qx
// module chunks = 0